import { useEffect } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import useChallengeSelector from '../../hooks/useChallengeSelector'
import { fetchChallenges } from '../../store/challengeSlice'
import { useAppDispatch, useAppSelector } from '../../store/store'
import { getBeltSelector } from '../../store/selectors'

const Belt = () => {
  const params = useParams()
  const belts = useAppSelector(getBeltSelector)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const beltID = Number(belts.nameMap[params.activeTab])
  const challenges = useChallengeSelector(beltID)

  useEffect(() => {
    if (!params.activeChallenge) {
      if (beltID && !challenges.length) {
        dispatch(
          fetchChallenges({
            beltID: beltID
          })
        )
      }
    }
  }, [beltID, challenges, dispatch, navigate, params.activeChallenge])

  useEffect(() => {
    if (!params.activeChallenge && challenges.length) {
      navigate(challenges[0].id, {
        replace: true
      })
    }
  }, [challenges, navigate, params.activeChallenge])

  return (
    <>
      <Outlet />
    </>
  )
}

export default Belt
